var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.742c.211 0 .402.083.54.22a.756.756 0 0 1 0 1.069.748.748 0 0 1-.53.219.747.747 0 0 1-.76-.75.748.748 0 0 1 .75-.76zm9 0c.211 0 .402.083.54.22a.756.756 0 0 1 0 1.069.748.748 0 0 1-.53.219.747.747 0 0 1-.76-.75.748.748 0 0 1 .75-.76zM3 .75l.462 2.999H19l-.568 7.617a2.246 2.246 0 0 1-2.076 1.995l-10.354.74a2.244 2.244 0 0 1-1.63-.54 2.241 2.241 0 0 1-.774-1.531l-.617-8.013-.213-2.768H1L3 .75z",
    stroke: "#191919",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartResponsive);
export default __webpack_public_path__ + "static/media/cart-responsive.350bee4e94225c096f168e782d74116e.svg";
export { ForwardRef as ReactComponent };